import {Component} from '@angular/core';
import {CardModule} from 'primeng/card';
import {TranslateModule} from '@ngx-translate/core';


@Component({
  selector: 'du-not-allowed',
  imports: [
    CardModule,
    TranslateModule
],
  templateUrl: './not-allowed.component.html',
  styleUrl: './not-allowed.component.scss'
})
export class NotAllowedComponent {

}
